// extracted by mini-css-extract-plugin
export var chevron = "_g7-2";
export var dropdownItems = "_g7-0";
export var item = "_g7-1";